module.exports = __webpack_public_path__ + "img/m3.1d8a3f4a.png";